<template>
  <section>
    <!-- <SectionTitle v-if="title" :title="title" /> -->
    <ItemsSlider gap="1.5" wrapperTagType="ul">
      <li
        v-for="(_, index) in Array.from({ length: skeletonNumbers })"
        :key="index"
      >
        <div
          class="h-[288px] animate-pulse card__two min-w-[130px] w-full border border-[#DEDEDE] rounded-[7px] overflow-hidden"
        >
          <!-- visual info -->
          <div class="relative">
            <!-- store bar -->
            <div
              class="bg-gray-200 absolute top-0 left-0 w-full py-2 px-3 text-[#FFFFFF] text-[11px] sm:text-[12px] 3xl:text-[13px] font-normal flex flex-nowrap items-center gap-1.5"
            >
              <span
                class="store__logo rounded-full p-1 grid bg-gray-300 place-items-center w-[22px] h-[22px] sm:w-[23px] sm:h-[23px] 3xl:w-[24px] 3xl:h-[24px]"
              />
              <span
                class="overflow-hidden whitespace-nowrap text-ellipsis bg-gray-300 h-[12px] w-[52px]"
              />
            </div>
            <!-- product image -->
            <div class="z-0 bg-gray-100 h-[179px] w-[100%]" />
            <!-- product rating -->
            <span
              class="gap-1.5 bg-gray-300 absolute bottom-2.5 w-[56px] h-[25px] rtl:left-2 rtl:right-auto left-auto right-2 text-[#FFFFFF] text-[12px] sm:text-[13px] 3xl:text-[14px] flex items-center rounded-[6px]"
            >
              <strong />
            </span>
          </div>
          <div class="px-3">
            <!-- price, description, favorite and production date -->
            <div>
              <div class="flex items-center h-[40px] justify-between w-full">
                <!-- price -->
                <div
                  class="text-[17px] sm:text-[18px] 3xl:text[19px] flex items-center gap-1"
                >
                  <strong class="bg-gray-200 w-[77px] h-[16px] font-bold" />
                  <span class="bg-gray-100 w-[23px] h-[8px]" />
                </div>
                <div>
                  <!-- favorite -->
                  <!-- <span class="bg-transparent border-0 px-2">
                      <img class="object-contain" :src="unfavedIcon" alt="" />
                    </span> -->
                </div>
              </div>
            </div>
            <!-- description -->
            <div
              class="px-2 bg-gray-200 w-[90%] h-[30px] h font-normal text-[13px] text-black product-description ellipsis-x2 sm:text-[14px] 3xl:text-[15px]"
            >
              <p class="transition-all duration-150" />
            </div>
            <!-- date -->
            <div class="px-2 bg-gray-200 w-[70%] mt-3 h-[11px]" />
          </div>
        </div>
      </li>
    </ItemsSlider>
  </section>
</template>
  
  <script>
import ItemsSlider from '../generic/ItemsSlider.vue';
export default {
  data() {
    return {
      skeletonNumbers: 8,
    };
  },
  components: {
    ItemsSlider
  }
};
</script>
  
  <style>
</style>